export default __webpack_public_path__ + "static/media/watermeloncooler@3x.36ba1fcb.jpg";